// extracted by mini-css-extract-plugin
export default {"FieldAssignedToWrapper":"FieldAssignedToWrapper---G93fL","FieldAssignedToButtonWrapper":"FieldAssignedToButtonWrapper---ZrtTf"};